import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import { Card, ErrorNotice } from '../components/ui.jsx';

const ENV_LABEL = import.meta.env.VITE_ENV_LABEL || 'Local';

export default function LoginPage() {
  const { user, signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={location.state?.from || '/dashboard'} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
      navigate(location.state?.from || '/dashboard', { replace: true });
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="brand-name">MMV Mapper</div>
          <div className="brand-sub">GIIB vehicle mapping platform</div>
        </div>
        <Card>
          <form onSubmit={submit}>
            <ErrorNotice error={error} />
            <div className="field">
              <label htmlFor="email">Email address</label>
              <input
                id="email" type="email" autoComplete="username" required
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <input
                id="password" type="password" autoComplete="current-password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              {busy ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
        </Card>
        <div className="prov" style={{ textAlign: 'center', marginTop: 12 }}>
          Environment: {ENV_LABEL}
        </div>
      </div>
    </div>
  );
}
